import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProfileContent from '../../../components/comment/profile/profileContent';
import VerifyProfileNow from '../verifyProfile/verifyProfileNow';
import DocumentsVerification  from '../documentsverify/documentsVerification';



const verificationContent = () => {
  return (
    <div className="main-account">
    <Container className="main-account-content ">
      <Row className="main-content pt-4 pb-5">
        <Col lg={3} className="content-left">
          <ProfileContent />
        </Col>

        <Col lg={9} className="content-right  " >
          <div className='verification-wrap'>
          <VerifyProfileNow />
          <DocumentsVerification />
         </div>
        </Col>
      </Row>
    </Container>
  </div>
  )
}

export default verificationContent